import { BookOpen } from "lucide-react";
import { useEffect, useState } from "react";
import { useT } from "../i18n/LanguageContext";

export const MenuFloat = () => {
  const { t } = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Nascondi quando si è dentro la sezione menu (per non coprire i contenuti)
      const menuEl = document.getElementById("menu");
      if (!menuEl) { setVisible(window.scrollY > 200); return; }
      const rect = menuEl.getBoundingClientRect();
      const inMenu = rect.top < window.innerHeight * 0.55 && rect.bottom > window.innerHeight * 0.4;
      setVisible(window.scrollY > 200 && !inMenu);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="#menu"
      data-testid="menu-float"
      aria-label={t("nav.menu")}
      className={`fixed z-50 right-6 bottom-[92px] md:bottom-[104px] inline-flex items-center gap-2.5 px-5 py-3.5 md:px-7 md:py-4 rounded-full bg-[var(--espresso)] text-[var(--ivory)] font-semibold uppercase tracking-[0.18em] text-[15px] md:text-[17px] shadow-[0_14px_36px_rgba(42,31,24,0.45)] transition-all duration-500 hover:-translate-y-0.5 hover:bg-[var(--gold-deep)] border-2 border-[var(--gold)] ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <BookOpen className="w-5 h-5 md:w-6 md:h-6" strokeWidth={2.2} />
      <span>{t("nav.menu")}</span>
    </a>
  );
};
